import React, { useCallback, useEffect, useState } from "react";

import { siteLocationPrefix } from "../../constants";
import * as styles from "./TestStyle.module.css";

type BillingAccountOverrideResponse = {
  allBillingCountriesOverride: boolean;
};

const billingCountriesUrl = `${siteLocationPrefix}/test/developer-store/billing-countries`;

export const TestBillingAccountActions = () => {
  const [data, setData] = useState<BillingAccountOverrideResponse | null>(null);
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

  const load = useCallback(async () => {
    const response = await fetch(billingCountriesUrl);
    if (!response.ok) {
      throw new Error(`Billing Account override failed to load: ${response.status}`);
    }
    setData((await response.json()) as BillingAccountOverrideResponse);
  }, []);

  useEffect(() => {
    load().catch(reason => setError((reason as Error).message));
  }, [load]);

  const setAllCountriesOverride = async (enabled: boolean) => {
    setSaving(true);
    setError("");
    try {
      const response = await fetch(billingCountriesUrl, {
        method: enabled ? "PUT" : "DELETE",
      });
      if (!response.ok) {
        throw new Error(`Billing countries override failed: ${response.status}`);
      }
      await load();
    } catch (reason) {
      setError((reason as Error).message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className={styles.generalActionsWrapper}>
      <h3>Billing Accounts</h3>
      <p>
        All-country override:{" "}
        <strong>{data?.allBillingCountriesOverride ? "enabled" : "disabled"}</strong>
      </p>
      <div>
        <button
          className={styles.testButton}
          type="button"
          disabled={!data || saving || data.allBillingCountriesOverride}
          onClick={() => setAllCountriesOverride(true)}
        >
          Enable all countries
        </button>{" "}
        <button
          className={styles.testButtonDanger}
          type="button"
          disabled={!data || saving || !data.allBillingCountriesOverride}
          onClick={() => setAllCountriesOverride(false)}
        >
          Disable all countries
        </button>
      </div>
      {error && <p role="alert">{error}</p>}
      <p>
        Test only. Billing account creation will show every supported country; Shipping Address
        countries still follow the selected Billing Account country.
      </p>
    </div>
  );
};
